import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrEmpty } from 'sigv-library/util';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss'],
})
export class IndexComponent implements OnInit {
  routeMap: Map<string, string>;

  constructor(private route: ActivatedRoute, private router: Router) {
    this.routeMap = new Map([
      ['WebSubmission_Approve', 'todo/list?status=Processing'],
      ['WebSubmission_Draft', 'todo/list?status=Draft'],
      ['WebSubmission_Return', 'todo/list?status=Return'],
      ['WebSubmission_WithdrawApproving', 'todo/list?status=WithdrawApproving'],
      ['AnnouncementSetting_Approve', 'todo/announcement-setting/approve'],
      ['AnnouncementSetting_Draft', 'todo/announcement-setting/draft'],
      ['AnnouncementSetting_Apply', 'todo/announcement-setting/apply'],
    ]);
  }
  ngOnInit(): void {
    this.redirect();
  }

  redirect(): void {
    const { processDefKey, taskDefKey } = this.route.snapshot.params;

    if (
      isNullOrEmpty(processDefKey) === false &&
      isNullOrEmpty(taskDefKey) === false
    ) {
      const availableRoute =
        this.routeMap.get(`${processDefKey}_${taskDefKey}`) ?? '';

      this.router.navigateByUrl(availableRoute);
    }
  }
}
